// Helper para os botões (garanta que essa função existe no seu escopo)
function disableInputButtons(status) {
	var buttons = $(document).find('[type="submit"]');
	buttons.each(function (btn) {
		$(buttons[btn]).prop('disabled', status);
	});
}

function exibirErro(element, mensagem) {
	element.classList.add('is-invalid');

	// ESTA LINHA É A CHAVE: Avisa o navegador que o campo é inválido
	element.setCustomValidity(mensagem);

	var listaErros = document.getElementById("lista-erros");
	var sumario = document.getElementById("validacao-sumario");

	if (listaErros && sumario) {
		var erroExistente = Array.from(listaErros.children).some(li => li.innerText === mensagem);
		if (!erroExistente) {
			var li = document.createElement("li");
			li.innerText = mensagem;
			li.dataset.campo = element.id;
			listaErros.appendChild(li);
		}
		sumario.style.display = "block";
	}
	return false;
}

function resetarErro(element) {
	element.classList.remove('is-invalid');

	// ESTA LINHA É A CHAVE: Limpa o erro para o navegador permitir o envio
	element.setCustomValidity("");

	var listaErros = document.getElementById("lista-erros");
	if (listaErros) {
		var itens = listaErros.querySelectorAll(`li[data-campo="${element.id}"]`);
		itens.forEach(item => item.remove());
		if (listaErros.children.length === 0) {
			var sumario = document.getElementById("validacao-sumario");
			if (sumario) sumario.style.display = "none";
		}
	}
}

//valida CpfCnpj
function validaCPFCNPJ(element) {

	var valorCampo = element.value.replace(/\D/g, '');
	var tamanhoValorCampo = (valorCampo).length;

	resetarErro(element);
	if (valorCampo == "") return true;

	// 2. Validação por tamanho
	if (tamanhoValorCampo == 11) {
		if (TestaCPF(valorCampo)) {
			return true;
		}
	}
	else if (tamanhoValorCampo == 14) {
		if (TestaCNPJ(valorCampo)) {
			return true;
		}
	}

	exibirErro(element, "CPF/CNPJ inválido!");
	return false;
}

//valida CpfCnpj
function validaCPF(element) {

	var valorCampo = element.value.replace(/\D/g, '');
	var tamanhoValorCampo = (valorCampo).length;
	var RegExp = /(^[\d]{3}[\d]{3}[\d]{3}[\d]{2}$)|(^[\d]{2}[\d]{3}[\d]{3}[\d]{4}[\d]{2}$)/;

	resetarErro(element);
	if (valorCampo == "") return true;

	if (RegExp.test(valorCampo) == true) {
		if (TestaCPF(valorCampo)) {
			return true
		}
	}

	exibirErro(element, "CPF inválido!");
	return false;
}

//valida CpfCnpj
function validaCNPJ(element) {

	var valorCampo = (element.value).replace(/\D/g, '');
	var tamanhoValorCampo = (valorCampo).length;
	var RegExp = /(^[\d]{3}[\d]{3}[\d]{3}[\d]{2}$)|(^[\d]{2}[\d]{3}[\d]{3}[\d]{4}[\d]{2}$)/;

	resetarErro(element);
	if (valorCampo == "") return true;

	if (RegExp.test(valorCampo) == true) {
		if (TestaCNPJ(valorCampo)) {
			return true;
		}
	}

	exibirErro(element, "CNPJ inválido!");
	return false;
}

//valida CPF
function TestaCPF(valorCampo) {
	var soma;
	var resto;
	soma = 0;

	// Elimina CPF's invalidos conhecidos
	if (valorCampo == "00000000000" ||
		valorCampo == "11111111111" ||
		valorCampo == "22222222222" ||
		valorCampo == "33333333333" ||
		valorCampo == "44444444444" ||
		valorCampo == "55555555555" ||
		valorCampo == "66666666666" ||
		valorCampo == "77777777777" ||
		valorCampo == "88888888888" ||
		valorCampo == "99999999999")
		return false;

	for (i = 1; i <= 9; i++) soma = soma + parseInt(valorCampo.substring(i - 1, i)) * (11 - i);
	resto = (soma * 10) % 11;

	if ((resto == 10) || (resto == 11)) resto = 0;
	if (resto != parseInt(valorCampo.substring(9, 10))) return false;

	soma = 0;
	for (i = 1; i <= 10; i++) soma = soma + parseInt(valorCampo.substring(i - 1, i)) * (12 - i);
	resto = (soma * 10) % 11;

	if ((resto == 10) || (resto == 11)) resto = 0;
	if (resto != parseInt(valorCampo.substring(10, 11))) return false;
	return true;
}

//valida CNPJ
function TestaCNPJ(CNPJ) {
	var validaArray = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
	var primeiroDigito = new Number;
	var segundoDigito = new Number;
	var digito = Number(eval(CNPJ.charAt(12) + CNPJ.charAt(13)));

	for (i = 0; i < validaArray.length; i++) {
		primeiroDigito += (i > 0 ? (CNPJ.charAt(i - 1) * validaArray[i]) : 0);
		segundoDigito += CNPJ.charAt(i) * validaArray[i];
	}
	primeiroDigito = (((primeiroDigito % 11) < 2) ? 0 : (11 - (primeiroDigito % 11)));
	segundoDigito = (((segundoDigito % 11) < 2) ? 0 : (11 - (segundoDigito % 11)));

	resultado = (((primeiroDigito * 10) + segundoDigito)) == digito ? true : false;
	return resultado;
}

//Valida CEP
function validaCEP(element) {

	var valorCampo = element.value;
	var tamanhoValorCampo = (valorCampo).length;

	resetarErro(element);
	if (valorCampo == "") return true;
	
	if (tamanhoValorCampo == 9) {
		return true;
	}

	exibirErro(element, "CEP inválido!");
	return false;
}

//Valida DataNasc
function validaDataNasc(element) {

	var valorCampo = (element.value);
	var tamanhoValorCampo = (valorCampo).length;

	resetarErro(element);
	if (valorCampo == "") return true;

	if (tamanhoValorCampo == 5) {
		return true;
	}

	exibirErro(element, "Mês/Ano inválido!");
	return false;
}

//Valida Telefone
function validaTelefone(element) {

	var valorCampo = (element.value);
	var tamanhoValorCampo = (valorCampo).length;

	resetarErro(element);
	if (valorCampo == "") return true;

	if (tamanhoValorCampo == 14 && valorCampo.substr(4, 1) == "9") {
		return true;
	}else if (tamanhoValorCampo == 13) {
		return true;
	}

	exibirErro(element, "Telefone inválido!");
	return false;
}

//Valida Email
function validaEmail(element) {

	var valorCampo = (element.value);	
	var er = new RegExp(/^[A-Za-z0-9_\-\.]+@[A-Za-z0-9_\-\.]{2,}\.[A-Za-z0-9]{2,}(\.[A-Za-z0-9])?/);

	resetarErro(element);
	if (valorCampo == "") return true;

	if (er.test(valorCampo)) {
		return true;
	}

	exibirErro(element, "Email inválido!");
	return false;
}

//Valida Senhas
function validaSenhas(idSenha1, idSenha2) {
	var inputSenha1 = document.getElementById(idSenha1);
	var inputSenha2 = document.getElementById(idSenha2);

	if ((inputSenha1.value == inputSenha2.value) && inputSenha2.value != "") {
		return true;
	}

	exibirErro(element, "Senhas não conferem!");
	return false;
}

//Valida Data
function validaData(element) {

	var valorCampo = (element.value);
	var ardt = new Array;
	var ExpReg = new RegExp("(0[1-9]|[12][0-9]|3[01])/(0[1-9]|1[012])/[12][0-9]{3}");
	ardt = valorCampo.split("/");
	var erro = false;

	resetarErro(element);
	if (valorCampo == "") return true;

	if (valorCampo != "") {
		if (valorCampo.search(ExpReg) == -1) {
			erro = true;
		}
		else if (((ardt[1] == 4) || (ardt[1] == 6) || (ardt[1] == 9) || (ardt[1] == 11)) && (ardt[0] > 30)) {
			erro = true;
		}
		else if (ardt[1] == 2) {
			if ((ardt[0] > 28) && ((ardt[2] % 4) != 0))
				erro = true;
			if ((ardt[0] > 29) && ((ardt[2] % 4) == 0))
				erro = true;
		}
	}

	if (erro == false) {
		return true;
	}

	exibirErro(element, "Data inválida!");
	return false;
}

//Valida Valor
function validaValor(element) {

	var valorCampo = (element.value);

	if (valorCampo == "") {
		element.value = "0,00";
    }
}

//Valida Numero
function validaNumero(element) {

	var valorCampo = (element.value);

	if (valorCampo == "") {
		element.value = "0";
	}
}


